/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1ReferralCode
 */
export interface V1ReferralCode {
    /**
     *
     */
    code: string
    /**
     *
     */
    link: string
    /**
     *
     */
    programId: string
}

/**
 * Check if a given object implements the V1ReferralCode interface.
 */
export function instanceOfV1ReferralCode(
    value: object
): value is V1ReferralCode {
    if (!('code' in value) || value['code'] === undefined) return false
    if (!('link' in value) || value['link'] === undefined) return false
    if (!('programId' in value) || value['programId'] === undefined)
        return false
    return true
}

export function V1ReferralCodeFromJSON(json: any): V1ReferralCode {
    return V1ReferralCodeFromJSONTyped(json, false)
}

export function V1ReferralCodeFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ReferralCode {
    if (json == null) {
        return json
    }
    return {
        code: json['code'],
        link: json['link'],
        programId: json['programId']
    }
}

export function V1ReferralCodeToJSON(json: any): V1ReferralCode {
    return V1ReferralCodeToJSONTyped(json, false)
}

export function V1ReferralCodeToJSONTyped(
    value?: V1ReferralCode | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        code: value['code'],
        link: value['link'],
        programId: value['programId']
    }
}
